module.exports = __webpack_public_path__ + "distribution/img/3.f60dacd2.png";